import React from 'react'
import { useAppSelector } from '../../app/hooks';
import TimeEntryInput from './TimeEntryInput';

const TimesheetRowWithControl = (props: any) => {
  const { timeEntriesList } = useAppSelector((state) => state.timesheet);
  const state = useAppSelector((state) => state.timesheet);
  const totalColumns = timeEntriesList.find(x => x.rowId === props.rowId).timeEntries
  const timeEntryColumns = timeEntriesList.find(x => x.rowId === props.rowId).timeEntries.map((x: any, i: any) =>{
    const showRelative = i >= totalColumns.length - 3;
    return(
    <TimeEntryInput
      key={i}
      detailRowId={i}
      rowId={props.rowId}
      showRelative={showRelative}
    />
  )});
  // const timeEntryColumns = timeEntriesList.find(x => x.rowId === props.rowId).timeEntries.map((x: any, i: any) =>
  //   <TimeEntryInput
  //     key={i}
  //     detailRowId={i}
  //     rowId={props.rowId}
  //   />
  // );
  return (
    <tr className={"timesheet-row cursor"}>
      {timeEntryColumns}
    </tr>
    // <>
    //   {timeEntriesList.map((x, i) =>
    //     x.isTimeOff == props.isTimeOff &&
    //     <tr className={"timesheet-row"} key={i}>
    //       {timeEntriesList[x.rowId].timeEntries.map((x1: any, i: any) =>
    //         <TimeEntryInput
    //           key={i}
    //           detailRowId={i}
    //           rowId={x1.rowId}
    //         />
    //       )}
    //     </tr>
    //   )}
    // </>
  );
}

export default TimesheetRowWithControl